/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NotificationDto } from '../../models/notification-dto';

export interface GetNotification$Params {
  id: string;
}

export function getNotification(http: HttpClient, rootUrl: string, params: GetNotification$Params, context?: HttpContext): Observable<StrictHttpResponse<NotificationDto>> {
  const rb = new RequestBuilder(rootUrl, getNotification.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<NotificationDto>;
    })
  );
}

getNotification.PATH = '/v0/notifications/{id}';
